import { apiUrl } from "config/settings";
import moment from "moment";
import http from 'http'
import { useDispatch, useSelector } from "react-redux";
import { setShowLoading } from "store/sysSlice";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { Checkbox, List, ListItem, Stack, Typography, useTheme } from "@mui/material";
import CustomButton from "components/CustomButton";
import CustomDialog from "components/CustomDialog";
import { useEffect, useState } from "react";

const RelayGroup = ({ open, setOpen, mcList }) => {
    const theme = useTheme();
    const { bt } = useBizTypeTranslation();
    const dispatch = useDispatch()
    const bizPath = useSelector((state) => state?.biz?.data?.path);
    const [checked, setChecked] = useState([])
    const [command, setCommand] = useState("off")

    // useEffect(() => {
    //     setChecked(mcList?.map(i => i?.guid) || [])
    // }, [mcList]);

    const onClose = () => {
        setOpen(false)
    }

    const sendCommand = (checked, value) => {

        let item = {
            guids: checked,
            turnOnDate: value === "off" ? null : moment(),
            turnOffDate: value === "on" ? null : moment(),
            command: value === "off" ? "off" : "on",
        }

        if ("vibrate" in navigator)
            navigator.vibrate(100);

        dispatch(setShowLoading(true));
        http.patch(`${apiUrl}/mc/sendCommandGroup/${bizPath}`, item)
            .then((res) => {
                dispatch(setShowLoading(false));
                onClose()
            })
            .catch((error) => {
                dispatch(setShowLoading(false));
                onClose()
            });
    }

    const selectedMc = (guid) => {
        let newChecked = [...checked]
        if (checked?.includes(guid))
            newChecked = newChecked?.filter(i => i !== guid)
        else
            newChecked?.push(guid)
        setChecked(newChecked)
    }

    return (
        <CustomDialog onClose={onClose} open={open} title="GROUP_COMMAND">
            <Stack minWidth={{ xs: '100%', md: 400 }} spacing={2}>

                <CustomButton
                    title={command === "off" ? "SELECTED_MCS_OFF" : "SELECTED_MCS_ON"}
                    fullWidth
                    onClick={() => setCommand(command === "on" ? "off" : "on")}
                    color={command === "on" ? "success.main" : "error.main"}
                    textColor={command === "on" ? "success.text" : "error.text"}
                    height={45}
                />

                <Stack direction="row" justifyContent="space-between" alignItems="center">

                    <Typography fontSize={14} >
                        {bt("SELECTED_MC_COUNT")} : {checked?.length}
                    </Typography>

                    <CustomButton
                        size="small"
                        fontSize={14}
                        title={checked?.length === mcList?.length ? "DESELECT_ALL" : "SELECT_ALL"}
                        textColor={checked?.length === mcList?.length ? "error.text" : "success.main"}
                        variant="text"
                        onClick={() => {
                            if (checked?.length === mcList?.length)
                                setChecked([])
                            else
                                setChecked(mcList?.map(i => i?.guid))
                        }}
                    />
                </Stack>

                <Stack width="100%" alignItems="center">

                    <List
                        sx={{
                            width: '100%',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 300,
                            '& ul': { padding: 0 },
                        }}
                        subheader={<li />}
                    >
                        {mcList.map((item) => (
                            <ListItem
                                key={item?.guid}
                                onClick={() => selectedMc(item?.guid)}
                                sx={{
                                    p: 0,
                                    border: `1px solid ${theme.palette.divider}`,
                                    borderRadius: 1,
                                    mb: 0.5,
                                    bgcolor: checked?.includes(item?.guid) ? "warning.light" : "bg.main"
                                }}
                            >
                                <Stack direction="row" spacing={1}>
                                    <Checkbox
                                        edge="end"
                                        onChange={() => selectedMc(item?.guid)}
                                        checked={checked.includes(item?.guid)}
                                    />

                                    <Stack>
                                        <Typography>{item?.name}</Typography>

                                        <Typography variant="caption" color={theme.palette.text.secondary}>
                                            {bt(item?.deviceType)} - {item?.area?.name}
                                        </Typography>
                                    </Stack>

                                </Stack>
                            </ListItem>
                        ))}
                    </List>
                </Stack>

                <Stack width='100%' direction='row' spacing={2}>
                    <CustomButton
                        color="error.main"
                        textColor="error.text"
                        height={45}
                        title='CANCEL'
                        fullWidth
                        onClick={() => onClose()}

                    />
                    <CustomButton
                        title='CONTINUE'
                        fullWidth
                        disabled={checked?.length === 0}
                        onClick={() => sendCommand(checked, command)}
                        color="success.main"
                        textColor="success.text"
                        height={45}
                    />
                </Stack>
            </Stack>
        </CustomDialog >
    )
}
export default RelayGroup